import { render, staticRenderFns } from "./alarm-properties.vue?vue&type=template&id=0dfbb6a9&"
import script from "./alarm-properties.vue?vue&type=script&lang=ts&"
export * from "./alarm-properties.vue?vue&type=script&lang=ts&"
import style0 from "./alarm-properties.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports